import { formatCalendarDate, isCalendarDate, parseCalendarDate } from '@nudool/shared';

const NOON = 12;

/** Local noon of the written day, so no zone offset can move it to a neighbouring day; `undefined`
 *  for anything but a real `YYYY-MM-DD`. */
export function ymdToLocalNoon(ymd: string): Date | undefined {
  if (!isCalendarDate(ymd)) return undefined;
  const [year, month, day] = ymd.split('-').map(Number);
  const date = new Date(2000, 0, 1, NOON);
  // setFullYear, not the constructor: `new Date(50, ...)` reads as 1950.
  date.setFullYear(year, month - 1, day);
  return date;
}

/** The local calendar day of `date` as `YYYY-MM-DD`; never `toISOString()`, which reads UTC. */
export function localDateToYmd(date: Date): string {
  const year = String(date.getFullYear()).padStart(4, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

/** `date` when it holds a real time; `undefined` for a missing value or an Invalid Date, which a
 *  picker shows as its placeholder rather than throwing during render. */
export function validDateOrUndefined(date: Date | undefined): Date | undefined {
  return date && !Number.isNaN(date.getTime()) ? date : undefined;
}

/** "Oct 2, 2026": the local day a picker holds, spelled the one way every picker shows a date.
 *  Throws on an Invalid Date: pass the value through `validDateOrUndefined` first. */
export function formatLocalDate(date: Date): string {
  return formatCalendarDate(parseCalendarDate(localDateToYmd(date)));
}
